import { responsive, useTheme } from '@wci-tech/core-ui';
import { css } from '@emotion/react';
import { useMemo } from 'react';

import { getContainerStyles } from '@/utils';

export const useStyles = () => {
  const { theme } = useTheme();

  return useMemo(
    () => ({
      wrapper: css`
        width: 100%;
        overflow: hidden;
      `,

      container: css`
        ${getContainerStyles(theme)};

        ${responsive.create({
          paddingTop: {
            default: theme.spacing.get(32),
            md: theme.spacing.get(100),
            lg: theme.spacing.get(130),
          },
          paddingBottom: {
            default: theme.spacing.get(30),
            md: theme.spacing.get(64),
            lg: theme.spacing.get(88),
          },
        })}
      `,

      sectionTitle: css`
        color: var(--text-color);
        text-align: center;
        opacity: 0.9;

        ${responsive.create({
          fontSize: {
            default: '20px',
            md: '30px',
            lg: '36px',
          },
        })}
      `,

      listContentWrapper: css`
        color: #424242;
        &:not([data-disabled='true']):hover {
          color: #424242;
        }
        &:not([data-disabled='true'])[data-selected='true'] {
          color: #424242;
        }
      `,

      listLabel: css`
        color: #424242 !important;
      `,

      sectionWrapper: css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        ${responsive.create({
          gap: {
            default: '0px',
            md: '16px',
          },
        })}

        &::after {
          content: '';
          display: block;
          background: linear-gradient(88.68deg, #4054d1 8.83%, #17ceca 115.83%);
          margin-left: auto;
          margin-right: auto;

          ${responsive.create({
            width: {
              default: '64px',
              md: '142px',
              lg: '200px',
            },
            height: {
              default: '4px',
              md: '8px',
              lg: '12px',
            },
            borderRadius: {
              default: '16px',
              md: '50px',
              lg: '35px',
            },
            marginTop: {
              default: '12px',
              md: '4px',
              lg: '16px',
            },
            marginBottom: {
              default: '20px',
              md: '48px',
              lg: '64px',
            },
          })}
        }
      `,

      subtitleWrapper: css`
        width: 100%;
        justify-content: center;
        align-items: center;

        ${responsive.create({
          display: {
            default: 'none',
            md: 'flex',
          },
        })}
      `,

      subtitle: css`
        color: var(--text-color);

        ${responsive.create({
          fontSize: {
            default: '14px',
            md: '20px',
            lg: '24px',
          },
        })}
      `,

      videoFrame: css`
        position: relative;
        flex: 0 0 auto;
        overflow: hidden;

        & > div {
          width: 100%;
          height: 100%;
        }

        video {
          display: block;
          width: 100%;
          height: 100%;
        }

        ${responsive.create({
          width: {
            default: '100%',
            md: '718px',
            lg: '958px',
          },
          height: {
            default: 'auto',
            md: '420px',
            lg: '581px',
          },
          minHeight: {
            default: 'auto',
            md: '420px',
            lg: '581px',
          },
          borderRadius: {
            default: '8px',
            md: '16px',
            lg: '20px',
          },
        })}
      `,

      videoPlayerContainer: css`
        ${responsive.create({
          borderRadius: {
            default: '8px',
            md: '16px',
            lg: '20px',
          },
        })}
      `,
    }),
    [theme],
  );
};
